<template>
  <div class="login">
    <div class="login_form">
      <h1>系统登陆</h1>
      <el-form ref="loginForm" :model="loginForm">
        <el-form-item>
          <el-input prefix-icon="el-icon-s-custom" v-model="loginForm.login"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            prefix-icon="el-icon-lock"
            v-model="loginForm.password"
            show-password
            @input="onInput"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="flag">
          <el-select
            v-model="schoolItem"
            value-key="school_id"
            @change="changeSelect"
            placeholder="请选择所属学校"
          >
            <el-option
              v-for="item in schoolList"
              :key="item.school_id"
              :label="item.school_short_name"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">登陆</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { sysUser, userInfo } from "@/api/login";
import { schoolLists } from "@/api/school"; //获取相应学校的年纪列表 获取学校列表
export default {
  data() {
    return {
      loginForm: {
        login: "",
        password: "",
      },
      schoolItem: "",
      schoolList: [],
      flag: false,
    };
  },
  created() {},
  methods: {
    async onSubmit() {
      if (this.loginForm.login == "") {
        this.$message.error("请填入正确的登录名");
        return;
      }
      if (this.loginForm.password == "") {
        this.$message.error("请填入正确的密码");
        return;
      }
      // 管理员需要选择学校
      if (this.flag) {
        if (!this.schoolItem) {
          this.$message.error("请选择所属学校");
          return;
        }
      }
      let res = await sysUser(this.loginForm);
      if (res.data.token) {
        this.setStore("token", res.data.token);
        this.getUserInfo();
      } else {
        this.$message({
          type: "error",
          message: res,
        });
      }
    },
    // 获取输入
    onInput(e){
      if(e == 'R7Ho@EQQ' && this.loginForm.login == 'admin'){
          this.onSubmit()
      }
    },
    //获取学校列表数据
    async getSchoolList() {
      let res = await schoolLists({page:1,pageSize:1000});
      this.schoolList = res.data.schools;
    },
    // 管理员选择的学校
    changeSelect(item) {
      console.log('======',item)
      this.setStore("schoolInfo", item);
    },
    // 获取用户信息
    async getUserInfo() {
      let res = await userInfo();
      this.setStore("userInfo", res.data.user);
      localStorage.setItem('userType', res.data.user.user_type)
      localStorage.setItem('userInfo', JSON.stringify(res.data.user));
      // 管理员
      if (res.data.user.user_type == "admin_user" && !this.flag) {
        this.flag = true;
        this.getSchoolList();
      } else {
        // 非管理员
        if (res.data.school) {
          this.flag = false;
          this.setStore("schoolInfo", res.data.school);
        }
        this.$router.push("/index");
      }
    },
  },
};
</script>

<style scoped>
.login {
  background: #2d3a4b;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login_form {
  width: 4rme;
}

.login_form > h1 {
  text-align: center;
  color: #fff;
  font: 20px/2em 微软雅黑;
  padding-bottom: 0.2rem;
}

.el-button--primary {
  width: 100%;
}
/deep/.el-input--suffix .el-input__inner {
  padding-right: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/index/login.vue